import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WfmDashboardComponent } from './wfm-dashboard/wfm-dashboard.component';
import { WfmFrameComponent } from './wfm-frame/wfm-frame.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [WfmDashboardComponent, WfmFrameComponent],
  imports: [
    CommonModule,
    RouterModule
  ]
})
export class WorkFlowManagerModule { }
